import React, { Component } from "react";
import { fixTime } from "../../helpers";
import { faBullseye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NavLink } from "react-router-dom";

class Submenu extends Component {
  createLinks = (element, index) => {
    let tempTime = fixTime(this.props.data[element].Time);
    return (
      <li key={index} className="submenu-2-element">
        <NavLink
          key={index}
          to={`/app/instructor-dashboard/${this.props.day}/${
            this.props.data[element].id
          }`}
        >
          <FontAwesomeIcon icon={faBullseye} /> {tempTime}
        </NavLink>
      </li>
    );
  };
  render() {
    return (
      <ul key={this.props.index} className="submenu-2">
        {Object.keys(this.props.data).map(this.createLinks)}
      </ul>
    );
  }
}

export default Submenu;
